require('./mortgageRequestMovingExpensesInformation.scss');

// @ vendors
const React = require('react');

// @ helper
const { FormattedText } = require('core/i18n').i18n;

// @ components
const { ContentBox } = require('commonsComponents/contentBox');

const MortgageRequestMovingExpensesInformation = () => {
    return (
        <ContentBox>
            <div className="mortgage-request-moving-expenses-information">
                <FormattedText
                    value="mortgageRequestMovingExpensesInformation-mortgageRequestMovingExpensesInformation_title"
                    className="mortgage-request-moving-expenses-information__title"
                />
                <FormattedText
                    value="mortgageRequestMovingExpensesInformation-mortgageRequestMovingExpensesInformation_paragraph"
                    className="mortgage-request-moving-expenses-information__paragraph"
                />
                <div className="mortgage-request-moving-expenses-information__contact">
                    <i className="icon icon-s-llamar" />
                    <FormattedText value="mortgageRequestMovingExpensesInformation-mortgageRequestMovingExpensesInformation_contact" />
                </div>
                <div className="mortgage-request-moving-expenses-information__mail">
                    <i className="icon icon-s-correo" />
                    <FormattedText
                        value="mortgageRequestMovingExpensesInformation-mortgageRequestMovingExpensesInformation_mail"
                        className="mortgage-request-moving-expenses-information__mail--address"
                    />
                </div>
            </div>
        </ContentBox>
    );
}

module.exports = MortgageRequestMovingExpensesInformation
